import styled from 'styled-components';

export const StyledTabPanel = styled.div`
    display: flex;
    flex-direction: column;
`;
